import { Flex } from 'core-components/library/flex'

import { AppLoaderSvg } from './appLoader/AppLoaderSvg'

import styles from './AppLoader.module.scss'

export const AppLoader = () => {
  return (
    <Flex
      flexDirection={'column'}
      className={styles.root}
      justifyContent={'center'}
      alignItems={'center'}
    >
      <Flex flexDirection={'column'} alignItems={'center'} width={'300px'}>
        <div className={styles.title}>Don't go anywhere, data's coming.</div>
        <AppLoaderSvg size={100} />
      </Flex>
    </Flex>
  )
}
